import { Action } from 'redux';
import { Customer } from 'src/types/model';

export interface State {
  loading: boolean;
  data: Customer[];
  error: string | null;
}

export const FETCH_CUSTOMER_REQUEST = 'FETCH_CUSTOMER_REQUEST';
export const FETCH_CUSTOMER_SUCCESS = 'FETCH_CUSTOMER_SUCCESS';
export const FETCH_CUSTOMER_FAILURE = 'FETCH_CUSTOMER_FAILURE';
export const SET_START_END_DATE = 'SET_START_END_DATE';

export interface FetchCustomerRequestAction
  extends Action<typeof FETCH_CUSTOMER_REQUEST> {}

export interface FetchCustomerSuccessAction
  extends Action<typeof FETCH_CUSTOMER_SUCCESS> {
  payload: Customer[];
}

export interface FetchCustomerFailureAction
  extends Action<typeof FETCH_CUSTOMER_FAILURE> {
  payload: string;
}

export interface FetchCustomerDateAction
  extends Action<typeof SET_START_END_DATE> {
  payload: {
    startDate: Date;
    endDate: Date;
  };
}

export type CustomerActionType =
  | FetchCustomerRequestAction
  | FetchCustomerSuccessAction
  | FetchCustomerFailureAction
  | FetchCustomerDateAction;
